// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/organization/MissionLaunchHistoryCard.jsx

import React from "react";

function formatDate(value) {
  if (!value) return "Pending";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

function readinessValue(value) {
  return value === null || value === undefined ? "—" : `${value}%`;
}

function launchConfigurationLabel(value) {
  const normalized = String(value || "").trim().toLowerCase();

  if (!normalized || normalized === "mission_launch.v1") {
    return "Initial organization setup";
  }

  if (normalized.includes("mission_launch")) {
    return "Organization launch workflow";
  }

  return "Configured launch workflow";
}

export default function MissionLaunchHistoryCard({ profile }) {
  const metadata = profile?.mission_launch_metadata || {};
  const launchVersion = profile?.mission_launch_version || metadata.version;

  return (
    <article className="enterprise-admin-organization-summary-card">
      <div>
        <p className="enterprise-admin-eyebrow">Mission Launch summary</p>
        <h3>Launch handoff</h3>
        <p>
          Review the organization setup carried forward from Mission Launch.
          Current operating decisions remain authoritative in Mission Control.
        </p>
      </div>
      <dl>
        <div>
          <dt>Completed</dt>
          <dd>{formatDate(profile?.mission_launch_completed_at || metadata.completed_at)}</dd>
        </div>
        <div>
          <dt>Launch configuration</dt>
          <dd title={launchVersion || "mission_launch.v1"}>
            {launchConfigurationLabel(launchVersion)}
          </dd>
        </div>
        <div>
          <dt>Readiness at launch</dt>
          <dd>
            {readinessValue(
              profile?.operational_readiness_at_launch ??
                metadata.operational_readiness_at_launch
            )}
          </dd>
        </div>
        <div>
          <dt>Current readiness</dt>
          <dd>{readinessValue(profile?.current_readiness ?? metadata.current_readiness)}</dd>
        </div>
      </dl>
    </article>
  );
}
